import React from 'react';
import alydMarketLogo from '../assets/alydMarketLogo.png';

const LoggedOutScreen = () => (
  <div style={{ padding: '2rem', textAlign: 'center' }}>
    <img
      src={alydMarketLogo}
      alt="SLP OT Logo"
      style={{
        width: '260px',
        maxWidth: '90%',
        height: 'auto',
        marginBottom: '2rem',
      }}
    />
    <h2>You’ve been logged out</h2>
    <p>Please close this window and log in again from the main app.</p>
  </div>
);

export default LoggedOutScreen;




